module.exports = __webpack_public_path__ + "fonts/text-regular.cc3face7.woff2";